var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ChangeEvent, ChangeEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class TokenInputAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onChange = new ChangeEventListener();
    }
    /**
     * Gets the "add token" expression.
     */
    getAddExpression() {
        return this.state.addExpression;
    }
    /**
     * Sets the "add token" expression.
     *
     * @param addExpression - The new value for the expression.
     */
    setAddExpression(addExpression) {
        this.setState({ addExpression });
    }
    /**
     * Returns if the input is enabled.
     */
    isEnabled() {
        return this.state.enabled;
    }
    /**
     * Sets if the input is enabled.
     *
     * @param enabled - If the input is enabled.
     */
    setEnabled(enabled) {
        this.setState({ enabled });
    }
    /**
     * Gets the name used as accessibility label.
     */
    getName() {
        return this.state.name;
    }
    /**
     * Sets the name used as accessibility label.
     *
     * @param name - The name for accessibility label.
     */
    setName(name) {
        this.setState({ name });
    }
    /**
     * Returns if the input is read only.
     */
    isReadOnly() {
        return Boolean(this.state.readOnly);
    }
    /**
     * Sets if the input is read only.
     *
     * @param readOnly - If the input is read only.
     */
    setReadOnly(readOnly) {
        this.setState({ readOnly });
    }
    /**
     * Gets the configured sensitiveness for the tokens.
     */
    getSensitiveData() {
        return this.state.sensitiveData;
    }
    /**
     * Sets if the token content should be hidden.
     *
     * @param sensitiveData - How sensitive the data is.
     */
    setSensitiveData(sensitiveData) {
        this.setState({ sensitiveData });
    }
    /**
     * Returns if the text is being struckthrough.
     */
    isStrikethrough() {
        return Boolean(this.state.strikethrough);
    }
    /**
     * Sets if the text should be struckthrough.
     *
     * @param strikethrough - If the text should be struckthrough.
     */
    setStrikethrough(strikethrough) {
        this.setState({ strikethrough });
    }
    /**
     * Gets the configured properties of the tokens.
     */
    getTokenProps() {
        return this.state.tokenProps;
    }
    /**
     * Sets the properties of the tokens.
     *
     * @param tokenProps - The properties of the tokens.
     */
    setTokenProps(tokenProps) {
        this.setState({ tokenProps });
    }
    /**
     * Gets the value of the input.
     */
    getValue() {
        return this.state.value ?? [];
    }
    /**
     * Sets the value of the input.
     *
     * @param value - The new value of the input.
     */
    setValue(value) {
        const { value: oldValue } = this.state;
        this.setState({ value });
        this.onChange.fire(new ChangeEvent({ oldValue, value }));
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TokenInputAPI.prototype, "onChange", void 0);
export { TokenInputAPI, };
//# sourceMappingURL=token-input-api.js.map